import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { Profile } from '../../components/Profile';
import {
  fetchUserInfo,
  fetchProfile,
  fetchTimeZone,
  fetchCountries,
  setProfile,
  changePassword,
  deleteProfile,
} from '../../actions';

const mapStateToProps = (state) => ({
  user: state.user.payload,
  pageLoading: state.user.pageLoading,
  loading: state.profile.loading,
  profile: state.profile.profile,
  timeZones: state.profile.timeZones,
  countries: state.profile.countries,
  err: state.profile.err,
});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      fetchUserInfo,
      fetchProfile,
      fetchTimeZone,
      fetchCountries,
      setProfile,
      changePassword,
      deleteProfile,
    },
    dispatch
  )

export default connect(mapStateToProps, mapDispatchToProps)(Profile);
